import React, { useState, useRef, useEffect } from "react";
import SellerDashboardHeader from "./SellerDashboardHeader";
import SellerSidebar from "./SellerSidebar";
import axios from "../axiosInstance";
import EditIcon from "@mui/icons-material/Edit";
import PreviewIcon from "@mui/icons-material/Preview";
import { ColorRing } from "react-loader-spinner";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

var images = "";
var arr1 = [];
var bedroomData = [];
var images1 = "";
var arr2 = [];
var dynamicObj = [];
var dynamicObj1 = [];

const AgentAddProperty = () => {
  const [charValue, setCharValue] = useState(0);
  const [propertyData, setPropertyData] = useState();
  const [oldGalleryImages, setOldGalleryImages] = useState();
  const [oldPropertyBedroom, setOldPropertyBedroom] = useState();
  const [oldFloorPlanImages, setOldFloorPlanImages] = useState();
  const [appendDiv, setAppendDiv] = useState([]);
  const [appendDiv1, setAppendDiv1] = useState([]);
  const [appendDiv2, setAppendDiv2] = useState([]);
  const [attachment, setAttachment] = useState(" ");
  const [seeImg2, setSeeImg2] = useState();
  const [count, setCount] = useState(1);
  const [count1, setCount1] = useState(1);
  const [count2, setCount2] = useState(0);
  const [visible, setVisible] = useState(false);
  const token = sessionStorage.getItem("token");
  const [name, setName] = useState();
  const [propertyBannerImg, setPropertyBannerImg] = useState();
  const [propertyImg, setPropertyImg] = useState();
  const [price, setMinPrice] = useState();
  const [max_price, setMaxPrice] = useState();
  const [address, setAddress] = useState();
  const [lat, setLat] = useState();
  const [lng, setLng] = useState();
  const [pdetails, setPDetails] = useState();
  const [beds, setBeds] = useState();
  const [bath, setBath] = useState();
  const [parking, setParking] = useState();
  const [min_area, setMinArea] = useState();
  const [max_area, setMaxArea] = useState();
  const [areaUnit, setAreaUnit] = useState();
  const [floorImg, setFloorImg] = useState();
  const [propertyId, setPropertyId] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  var myFloorType = [];
  const [removedImg, setRemovedImg] = useState([]);
  const [galleryId, setGalleryId] = useState();
  const [galleryName, setGalleryName] = useState();
  const [galleryImage, setGalleryImage] = useState();
  const [typeList, setTypeList] = useState();
  const [planList, setPlanList] = useState();
  const [typeArr, setTypeArr] = useState();
  const [planId, setPlanId] = useState();
  const [brochureImage, setBrochureImage] = useState();
  const [builder, setBuilder] = useState();
  const [builderList, setBuilderList] = useState();
  const [shortDesc, setShortDesc] = useState();
  const [propertyVideo, setPropertyVideo] = useState();
  const [propertyStatus, setPropertyStatus] = useState();
  const [amenities, setAmenitites] = useState([]);
  const [floorTypeArray, setFloorTypeArray] = useState("");
  var amenitiesList = useRef([]);
  const [propertyRecentSection, setPropertyRecentSection] = useState(0);
  const [propertyPopularSection, setPropertyPopularSection] = useState(0);
  const [saveCount, setSaveCount] = useState(0);
  const [AddCount, setAddCount] = useState(0);
  const [bedroomArray, setBedroomArray] = useState({
    name: "",
    type: "",
    area: "",
    price: "",
  });

  const [tags, setTags] = useState([]);
  const [seoTitle, setSeoTitle] = useState();
  const [seoDescription, setSeoDescription] = useState();

  const columns = [
    {
      name: "Plan Id",
      selector: (row) => row.plan_id,
      width: "70px",
    },
    {
      name: "Builder Id",
      selector: (row) => row.builderId,
      width: "88px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      width: "200px",
    },
    // {
    //     name: "Action",
    //     selector: (row) => <button className="btn btn-danger" data-toggle="modal" data-target="#exampleModal4" onClick={() => collectData(row)}>Edit</button>,
    //     width: '100px'
    // },
    {
      name: "Category",
      selector: (row) => row.category,
      width: "90px",
    },
    {
      name: "Image",
      selector: (row) => (
        <div>
          <img
            src={"https://api.divinebricks.com" + row.image}
            style={{ maxWidth: "100px", height: "50px" }}
          />
        </div>
      ),
    },
    // {
    //     name: "Bedrooms",
    //     selector: (row) => row.min_beds,
    // },
    // {
    //     name: "Bathrooms",
    //     selector: (row) => row.min_bath,
    // },
    {
      name: "Address",
      selector: (row) => row.address,
      width: "200px",
    },
    // {
    //     name: "Area",
    //     selector: (row) => <div>{row.min_area} {row.area_unit}</div>,
    //     width: '140px'
    // },
    {
      name: "Amount",
      selector: (row) => "$" + row.price,
    },
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => (
        <div
          className={
            row.is_status == "booked"
              ? "badge badge-danger p-2"
              : "badge badge-success p-2"
          }
        >
          {row.is_status}
        </div>
      ),
      width: "80px",
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <button
            className="mx-2"
            data-toggle="modal"
            data-target="#exampleModal6"
            onClick={() => collectData(row)}
            style={{
              padding: "10px",
              lineHeight: "20px",
              border: "none",
              background: "transparent",
            }}
          >
            <PreviewIcon />
          </button>
          <button
            data-toggle="modal"
            data-target="#exampleModal4"
            onClick={() => collectData(row)}
            style={{
              padding: "10px",
              lineHeight: "20px",
              border: "none",
              background: "transparent",
            }}
          >
            <EditIcon style={{ width: "0.8em" }} />
          </button>
        </div>
      ),
      width: "160px",
    },
  ];

  function handleToggle(e) {
    const { value, checked } = e.target;

    if (checked) {
      setAmenitites((pre) => [...pre, value]);
    } else {
      setAmenitites((pre) => {
        return [...pre.filter((skill) => skill !== value)];
      });
    }
  }

  function handleGalleryId(data) {
    setGalleryId(data.id);
    setGalleryName(data.name);
    setGalleryImage(data.img_url);
  }

  const collectData = (row) => {
    axios
      .post(
        `api/users/get-property-gallery`,
        {
          propertyId: row.id.toString(),
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setOldGalleryImages(resp.data.result?.gallery);
        setOldFloorPlanImages(resp.data.result?.floorplans);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .post(
        `api/users/get-property-bedroom`,
        {
          propertyId: row.id.toString(),
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setOldPropertyBedroom(resp.data.result);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
    setPropertyId(row.id);
    setName(row.name);
    setPropertyBannerImg(row.banner);
    setPropertyImg(row.image);
    setMinPrice(row.price);
    setMaxPrice(row.max_price);
    setAddress(row.address);
    setCity(row.city);
    setState(row.state);
    setAddress(row.address);
    setAmenitites(row.ameties);
    setPlanId(row.id);
    setTypeArr(row.typeArr);
    setLat(row.lat);
    setLng(row.lng);
    setShortDesc(row.short_details);
    setBrochureImage(row.brochure);
    setBuilder(row.builderId);
    setPDetails(row.pdetails);
    setFloorImg(row.floor_plans);
    setBeds(row.min_beds);
    setBath(row.min_bath);
    setParking(row.parking);
    setMinArea(row.min_area);
    setMaxArea(row.max_area);
    setPropertyVideo(row.video_link);
  };

  function emptyStates() {
    arr1 = [];
    arr2 = [];
    setCount2(0);
  }

  const addTags = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      setTags([...tags, event.target.value]);
      event.target.value = "";
    }
  };
  const removeTags = (index) => {
    setTags([...tags.filter((tag) => tags.indexOf(tag) !== index)]);
  };

  // function maxLength(el) {
  //     if (!('maxLength' in el)) {
  //         var max = el.attributes.maxLength.value;
  //         el.onkeypress = function () {
  //             setCharValue(this.value.length)
  //             if (this.value.length >= max) return false;
  //         };
  //     }
  // }
  // function maxLengthFunction() {
  //     maxLength(document.getElementById("text-lim"));
  //     if (shortDesc && shortDesc.length !== 0) {
  //         console.log(shortDesc.length + 1)
  //         setCharValue(shortDesc.length + 1)
  //     }
  // }

  function getCharLength(event) {
    setCharValue(event.target.value.length);
  }

  function handleOnChange(e) {
    setFloorTypeArray((pre) => [...pre, e.target.value]);
  }
  const fetchData = () => {
    axios
      .get(`api/users/get-property-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setPropertyData(resp.data.result?.propertyList);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/users/get-home-ameties-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        amenitiesList.current = [];
        for (var i = 0; i < resp.data.result.length; i++) {
          amenitiesList.current.push(resp.data.result[i].name);
        }
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/admins/get-admin-builder-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setBuilderList(resp.data.result.docs);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/users/get-type-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setTypeList(resp.data.result);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/users/get-plan-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setPlanList(resp.data.result);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  function handleFloorArray(e) {
    const { name, value } = e.target;
    setBedroomArray((prev) => {
      return { ...prev, [name]: value };
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    var obj1 = {};
    var obj2 = {};
    var obj3 = {};
    var myImages = [];
    var myImages1 = [];
    var myImages2 = [];
    for (var i = 0; i < arr1.length; i++) {
      myImages[i] = arr1[i];
      obj1[i] = { name: name, img_url: myImages[i] };
      dynamicObj.push(obj1[i]);
    }
    for (var i = 0; i < arr2.length; i++) {
      myImages1[i] = arr2[i];
      obj2[i] = { type: floorTypeArray[i], img_url: myImages1[i] };
      dynamicObj1.push(obj2[i]);
    }
    setVisible(true);
    axios
      .post(
        `api/users/add-property`,
        {
          name: name,
          plan_id: planId.toString(),
          banner: propertyBannerImg,
          image: propertyImg,
          price: price,
          max_price: max_price,
          builderId: builder.toString(),
          address: address,
          ameties: amenities.toString(),
          city: city,
          state: state,
          typeArr: typeArr,
          brochure: brochureImage,
          lat: "50",
          lng: "50",
          pdetails: pdetails,
          floor_plans: dynamicObj1,
          min_beds: beds,
          min_bath: bath,
          parking: parking,
          min_area: min_area,
          max_area: max_area,
          area_unit: "Square Feet",
          gallery: dynamicObj,
          short_details: shortDesc,
          video_link: propertyVideo,
          bedrooms: bedroomData,
          recent_property: propertyRecentSection,
          populer_property: propertyPopularSection,
          seo_title: seoTitle,
          seo_description: seoDescription,
          seo_keywords: tags,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setVisible(false);
        if (!resp.data.success) {
          toast.error(resp.data.msg, { toastId: "e1" });
        }
        if (resp.data.success) {
          toast(resp.data.msg, { toastId: "s1" });
          $("[data-dismiss=modal]").trigger({ type: "click" });
          dynamicObj = [];
          dynamicObj1 = [];
        }
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  };

  const editForm = (e) => {
    e.preventDefault();
    setVisible(true);
    axios
      .post(
        `api/users/update-property`,
        {
          propertyId: propertyId.toString(),
          name: name,
          // plan_id: planId.toString(),
          banner: propertyBannerImg,
          image: propertyImg,
          price: price,
          max_price: max_price,
          brochure: brochureImage,
          builderId: builder.toString(),
          address: address,
          city: city,
          state: state,
          ameties: amenities,
          typeArr: typeArr,
          lat: "50",
          lng: "50",
          pdetails: pdetails,
          floor_plans: floorImg,
          min_beds: beds.toString(),
          min_bath: bath.toString(),
          parking: parking,
          min_area: min_area.toString(),
          max_area: max_area.toString(),
          area_unit: "Square Feet",
          short_details: shortDesc,
          video_link: propertyVideo,
          is_status: propertyStatus,
          recent_property: propertyRecentSection,
          populer_property: propertyPopularSection,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setVisible(false);
        if (!resp.data.success) {
          toast.error(resp.data.msg, { toastId: "e1" });
        }
        if (resp.data.success) {
          toast(resp.data.msg, { toastId: "s1" });
          $("[data-dismiss=modal]").trigger({ type: "click" });
        }
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  };

  $(document).on("click", ".remove-btn", function () {
    $(this).parent().remove();
    // setRemovedImg.push($(this).parent().find('img').attr('id'))
    setCount(count - 1);
  });

  const addDiv = () => {
    var val = [...appendDiv, []];
    setAppendDiv(val);
    appendDiv.push(`hello`);
    // appendDiv.push(`<div className="col-md-4 copy-div mb-3"><input className="form-control imageUpload2" type="file" id="myfile" name="myfile" onChange={imageUpload2} /><button className="btn btn-danger remove-btn">-</button><br /> <img className="upload-img" id="output${count}" src={"https://api.divinebricks.com" + attachment} alt="your image" /></div>`)
    setCount(count + 1);
  };
  const addDiv1 = () => {
    var val = [...appendDiv1, []];
    setAppendDiv1(val);
    appendDiv1.push(` `);
    // appendDiv.push(`<div className="col-md-4 copy-div mb-3"><input className="form-control imageUpload2" type="file" id="myfile" name="myfile" onChange={imageUpload2} /><button className="btn btn-danger remove-btn">-</button><br /> <img className="upload-img" id="output${count}" src={"https://api.divinebricks.com" + attachment} alt="your image" /></div>`)
    setCount1(count1 + 1);
  };

  const addDiv2 = () => {
    if (saveCount != AddCount) {
      toast.error("Please save previous data");
      return;
    }
    setAddCount(AddCount + 1);
    var val = [...appendDiv2, []];
    setAppendDiv2(val);
    appendDiv2.push(`hello`);
    // bedroomData.push(bedroomArray)
    // appendDiv.push(`<div className="col-md-4 copy-div mb-3"><input className="form-control imageUpload2" type="file" id="myfile" name="myfile" onChange={imageUpload2} /><button className="btn btn-danger remove-btn">-</button><br /> <img className="upload-img" id="output${count}" src={"https://api.divinebricks.com" + attachment} alt="your image" /></div>`)
    setCount2(count2 + 1);
  };
  function handleFloorTypes() {
    bedroomData.push(bedroomArray);
  }

  function saveArr() {
    if (saveCount != AddCount - 1) {
      toast.error("Please add new block");
      return;
    }
    setSaveCount(saveCount + 1);
    bedroomData.push(bedroomArray);
  }

  const imageUpload2 = async (event) => {
    var id = $(event.target).parent().find("img").attr("id");
    setSeeImg2("visible");
    var output1 = document.getElementById(id);
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile2(event.target.files[0]);
  };

  function uploadFile2(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        arr1.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload16 = async (event) => {
    var id = $(event.target).parent().find("img").attr("id");
    setSeeImg2("visible");
    var output1 = document.getElementById(id);
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile16(event.target.files[0]);
  };

  function uploadFile16(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        arr2.push(resp.data.result.image_url);
        images1 = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload20 = async (event) => {
    var id = $(event.target).parent().find("img").attr("id");
    var output1 = document.getElementById(id);
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile20(event.target.files[0]);
  };

  function uploadFile20(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        // setAttachment(resp.data.result.img_url)
        setVisible(false);
        axios
          .post(
            `api/users/add-property-gallery`,
            {
              propertyId: propertyId.toString(),
              name: "img",
              img_url: resp.data.result.image_url,
            },
            {
              headers: {
                "x-access-token": token,
              },
            }
          )
          .then((resp) => {
            setVisible(false);
            // setPropertyImg(resp.data.result.image_url)
          })
          .catch((err) => {
            console.log("eerr", err);
            setVisible(false);
          });
        arr1.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload10 = async (event) => {
    var output1 = document.getElementById("output_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile10(event.target.files[0]);
  };

  function uploadFile10(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    // axios
    //     .get(
    //         `api/users/get-property-list`,
    //         {
    //             headers: {
    //                 "x-access-token": token,
    //             },
    //         }
    //     )
    //     .then((resp) => {
    //         setPropertyData(resp.data.result?.propertyList)
    //     })
    //     .catch((err) => {
    //         console.log(err)
    //     });
    // const config = {
    //     headers: {
    //         'content-type': 'multipart/form-data',
    //     },
    // };

    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        axios
          .post(
            `api/users/update-property-gallery`,
            {
              galleryId: galleryId.toString(),
              type: "Gallery",
              name: galleryName,
              img_url: resp.data.result.image_url,
            },
            {
              headers: {
                "x-access-token": token,
              },
            }
          )
          .then((resp) => {
            setVisible(false);
            if (resp.data.success) {
              $("[data-dismiss=modal]").trigger({ type: "click" });
              toast.success(resp.data.msg, { toastId: "succ1" });
              axios
                .post(
                  `api/users/get-property-gallery`,
                  {
                    propertyId: propertyId.toString(),
                  },
                  {
                    headers: {
                      "x-access-token": token,
                    },
                  }
                )
                .then((resp) => {
                  setOldGalleryImages(resp.data.result?.gallery);
                })
                .catch((err) => {
                  console.log(err);
                  setVisible(false);
                });
            } else {
              toast.error(resp.data.msg, { toastId: "erro1" });
            }
            setPropertyImg(resp.data.result.image_url);
          })
          .catch((err) => {
            console.log("eerr", err);
            setVisible(false);
          });
        arr1.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload9 = async (event) => {
    var output1 = document.getElementById("output_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile100(event.target.files[0]);
  };

  function uploadFile100(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    axios
      .get(`api/users/get-property-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setPropertyData(resp.data.result?.propertyList);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(`api/users/upload-a-document`, formData, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setVisible(false);
        axios
          .post(
            `api/users/update-property-gallery`,
            {
              galleryId: galleryId.toString(),
              type: "Floor Plans",
              name: galleryName,
              img_url: resp.data.result.image_url,
            },
            {
              headers: {
                "x-access-token": token,
              },
            }
          )
          .then((resp) => {
            setVisible(false);
            if (resp.data.success) {
              $("[data-dismiss=modal]").trigger({ type: "click" });
              toast.success(resp.data.msg, { toastId: "succ1" });
              axios
                .post(
                  `api/users/get-property-gallery`,
                  {
                    propertyId: propertyId.toString(),
                    type: "Floor Plans",
                  },
                  {
                    headers: {
                      "x-access-token": token,
                    },
                  }
                )
                .then((resp) => {
                  setOldFloorPlanImages(resp.data.result?.floorplans);
                })
                .catch((err) => {
                  console.log(err);
                  setVisible(false);
                });
            } else {
              toast.error(resp.data.msg, { toastId: "erro1" });
            }
            setPropertyImg(resp.data.result.image_url);
          })
          .catch((err) => {
            console.log("eerr", err);
            setVisible(false);
          });
        arr2.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  }

  const imageUpload1 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile1(event.target.files[0]);
  };

  function uploadFile1(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setPropertyImg(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }
  const imageUpload0 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output_banner_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile0(event.target.files[0]);
  };

  function uploadFile0(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setPropertyBannerImg(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload11 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output_brochure_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile11(event.target.files[0]);
  };

  function uploadFile11(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setBrochureImage(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload3 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output1");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile3(event.target.files[0]);
  };

  function uploadFile3(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setFloorImg(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  return (
    <>
      <div
        style={{ height: "100%", background: "#F1EFDC", paddingBottom: "20px" }}
      >
        <div className="row">
          <SellerDashboardHeader />
          <div className="d-flex" style={{ width: "100%" }}>
            <SellerSidebar />
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div
                    className="seller-body-content"
                    style={{ paddingLeft: 0 }}
                  >
                    {visible ? <div className="screen-overlay"></div> : ""}
                    <ColorRing
                      visible={visible}
                      ariaLabel="loading"
                      wrapperClass="loader-spinner"
                    />
                    {/* <div className="row">
                                            <div className="col-lg-12 col-md-12">
                                                <div className="card">
                                                    <div className="card-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <h4 className="card-title" style={{ textAlign: 'left' }}>Properties List</h4>
                                                        <button className="btn btn-danger" data-toggle="modal" data-target="#exampleModal" onClick={emptyStates}>Add Property</button>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="table-responsive export-button-table">
                                                            <DataTable
                                                                pagination={true}
                                                                columns={columns}
                                                                data={propertyData}
                                                                paginationServer={true}
                                                                paginationRowsPerPageOptions={[10, 50, 100, 500]}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                    {/* <div style={{textAlign: 'left'}}>
                                            <button className="btn btn-danger mb-4" onClick={emptyStates}>Add Property</button>
                                        </div> */}
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Add Property Details
                        </h5>
                      </div>
                      <div className="modal-body add-property-modal">
                        <div className="row admin-property-add">
                          <div className="col-md-4 mb-4">
                            <label>Select Plan</label>
                            <select
                              className="form-control"
                              value={planId}
                              onChange={(e) => setPlanId(e.target.value)}
                            >
                              <option disabled selected>
                                Select Type
                              </option>
                              {planList?.map((data) => {
                                return (
                                  <option value={data.id}>{data.name}</option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Select Builder</label>
                            <select
                              className="form-control"
                              value={builder}
                              onChange={(e) => setBuilder(e.target.value)}
                            >
                              <option disabled selected>
                                Select Builder
                              </option>
                              {builderList?.map((data) => {
                                return (
                                  <option value={data.id}>{data.name}</option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Property Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Property Name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Select Type</label>
                            <select
                              className="form-control"
                              value={typeArr}
                              onChange={(e) => setTypeArr(e.target.value)}
                            >
                              <option disabled selected>
                                Select Type
                              </option>
                              {typeList?.map((data) => {
                                return (
                                  <option value={data.name}>{data.name}</option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Property Image</label>
                            <input
                              type="file"
                              className="form-control"
                              placeholder="Enter Property Image"
                              onChange={imageUpload1}
                            />
                            <img
                              id="output_image"
                              alt="your image"
                              style={{
                                height: "100px",
                                width: "100px",
                                marginTop: "10px",
                                objectFit: "cover",
                                display: "none",
                              }}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Property Banner Image</label>
                            <input
                              type="file"
                              className="form-control"
                              placeholder="Enter Property Image"
                              onChange={imageUpload0}
                            />
                            <img
                              id="output_banner_image"
                              alt="your image"
                              style={{
                                height: "100px",
                                width: "100px",
                                marginTop: "10px",
                                objectFit: "cover",
                                display: "none",
                              }}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Property Brochure Image</label>
                            <input
                              type="file"
                              className="form-control"
                              placeholder="Enter Property Image"
                              onChange={imageUpload11}
                            />
                            <img
                              id="output_brochure_image"
                              alt="your image"
                              style={{
                                height: "100px",
                                width: "100px",
                                marginTop: "10px",
                                objectFit: "cover",
                                display: "none",
                              }}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Property Video</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Property Video Link"
                              value={propertyVideo}
                              onChange={(e) => setPropertyVideo(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Gallery Images</label>
                            <br />
                            <button
                              className="btn btn-danger"
                              data-toggle="modal"
                              data-target="#exampleModal2"
                              onClick={() => {}}
                            >
                              Upload
                            </button>
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Floor Plans Images</label>
                            <br />
                            <button
                              className="btn btn-danger"
                              data-toggle="modal"
                              data-target="#exampleModal7"
                            >
                              Upload
                            </button>
                            {/* <input type="file" className="form-control" placeholder="Enter Floor Plans Image" onChange={imageUpload3} />
                                                <img id="output1" alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', display: 'none' }} /> */}
                          </div>

                          {/* <div className="col-md-4 mb-4">
                            <label>Enter Floor Type</label>
                            <br />
                            <button
                              className="btn btn-danger"
                              data-toggle="modal"
                              data-target="#exampleModal8"
                            >
                              Upload
                            </button>
                          </div> */}
                          <div className="col-md-4 mb-4">
                            <label>Enter Min Price</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Price"
                              value={price}
                              onChange={(e) => setMinPrice(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Max Price</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Price"
                              value={max_price}
                              onChange={(e) => setMaxPrice(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter No of Bedrooms</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Bedrooms"
                              value={beds}
                              onChange={(e) => setBeds(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter No of Bathrooms</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Bathrooms"
                              value={bath}
                              onChange={(e) => setBath(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Property Address</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Property Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter City</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Property Address"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter State</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Property Address"
                              value={state}
                              onChange={(e) => setState(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Parking Facility</label>
                            <select
                              className="form-control"
                              value={parking}
                              onChange={(e) => setParking(e.target.value)}
                            >
                              <option disabled selected>
                                Parking Available
                              </option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                            </select>
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Min Property Size (Squ.. Feet)</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Property Size"
                              value={min_area}
                              onChange={(e) => setMinArea(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Max Property Size (Squ.. Feet)</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Property Size"
                              value={max_area}
                              onChange={(e) => setMaxArea(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Property Status</label>
                            <select className="form-control">
                              <option disabled selected>
                                Select Status
                              </option>
                              <option value="Active">Active</option>
                              <option value="Inactive">Inactive</option>
                            </select>
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Recent Property Section</label>
                            <select
                              className="form-control"
                              onChange={(e) =>
                                setPropertyRecentSection(e.target.value)
                              }
                            >
                              <option disabled selected>
                                Recent Property
                              </option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </div>
                          <div className="col-md-4 mb-4">
                            <label>Enter Popular Property Section</label>
                            <select
                              className="form-control"
                              onChange={(e) =>
                                setPropertyPopularSection(e.target.value)
                              }
                            >
                              <option disabled selected>
                                Popular Property
                              </option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </div>
                          <div
                            className="d-flex w-100 container mb-3"
                            style={{ flexWrap: "wrap", columnGap: "20px" }}
                          >
                            {amenitiesList.current?.map((data) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    id="check-3"
                                    type="checkbox"
                                    name="check"
                                    style={{ marginRight: "10px" }}
                                    value={data}
                                    onChange={handleToggle}
                                  />
                                  <label
                                    htmlFor="check-3"
                                    style={{
                                      marginBottom: "0",
                                      paddingBottom: "0",
                                    }}
                                  >
                                    {data}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                          <div
                            className="col-md-12 mb-3"
                            style={{ textAlign: "left" }}
                          >
                            <label>Enter Property Short Description</label>
                            <textarea
                              maxLength="255"
                              id="text-lim"
                              className="form-control"
                              placeholder="Enter Description"
                              value={shortDesc}
                              onChange={(e) => {
                                setShortDesc(e.target.value);
                                getCharLength(e);
                              }}
                            ></textarea>
                            <p style={{ color: "red", marginBottom: "0" }}>
                              Max Characters {charValue}/255
                            </p>
                          </div>
                          <div
                            className="col-md-12 mb-4"
                            style={{ textAlign: "left" }}
                          >
                            <label>Enter Property Details</label>
                            <ReactQuill
                              theme="snow"
                              value={pdetails}
                              onChange={(value) => setPDetails(value)}
                            />
                            {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                          </div>
                          <div
                            className="col-md-12 mb-4"
                            style={{ textAlign: "left" }}
                          >
                            <label>Enter Property Meta Title</label>
                            <input
                              type="text"
                              placeholder="Enter Meta title"
                              className="form-control"
                              value={seoTitle}
                              onChange={(e) => setSeoTitle(e.target.value)}
                            />
                            {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                          </div>
                          <div
                            className="col-md-12 mb-4"
                            style={{ textAlign: "left" }}
                          >
                            <label>Enter Property Meta Keywords</label>
                            <div className="tags-input">
                              {/* <ul className="custom-tags">
                                {tags?.map((tag, index) => (
                                    <li key={index} className="tag">
                                    <span className='tag-title'>{tag}</span>
                                    <i
                                        className="tag-close-icon"
                                        onClick={() => removeTags(index)}
                                    >
                                        x
                                    </i>
                                    </li>
                                ))}
                                </ul> */}
                              <input
                                type="text"
                                // onKeyUp={(event) => addTags(event)}
                                placeholder="Press enter to add tags"
                                value={tags}
                                onChange={(e) => setTags(e.target.value)}
                              />
                            </div>
                            {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                          </div>
                          <div
                            className="col-md-12 mb-4"
                            style={{ textAlign: "left" }}
                          >
                            <label>Enter Property Meta Description</label>
                            <input
                              type="text"
                              placeholder="Enter Meta Description"
                              className="form-control"
                              value={seoDescription}
                              onChange={(e) =>
                                setSeoDescription(e.target.value)
                              }
                            />
                            {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                        >
                          Save changes
                        </button>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal4"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Edit Property Details
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body add-property-modal">
                            <div className="row admin-property-add">
                              {/* <div className="col-md-4 mb-4">
                                                <label>Select Plan</label>
                                                <select className="form-control" value={planId} onChange={(e) => setPlanId(e.target.value)}>
                                                    <option disabled selected>Select Type</option>
                                                    {planList?.map((data) => {
                                                        return (
                                                            <option value={data.id}>{data.name}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div> */}
                              <div className="col-md-4 mb-4">
                                <label>Select Builder</label>
                                <select
                                  className="form-control"
                                  value={builder}
                                  onChange={(e) => setBuilder(e.target.value)}
                                >
                                  <option disabled selected>
                                    Select Builder
                                  </option>
                                  {builderList?.map((data) => {
                                    return (
                                      <option value={data.id}>
                                        {data.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Select Type</label>
                                <select
                                  className="form-control"
                                  value={typeArr}
                                  onChange={(e) => setTypeArr(e.target.value)}
                                >
                                  <option disabled selected>
                                    Select Type
                                  </option>
                                  {typeList?.map((data) => {
                                    return (
                                      <option value={data.name}>
                                        {data.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Name"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Image</label>
                                <input
                                  type="file"
                                  className="form-control"
                                  placeholder="Enter Property Image"
                                  onChange={imageUpload1}
                                />
                                <img
                                  id="output_image"
                                  alt="your image"
                                  style={{
                                    height: "100px",
                                    width: "100px",
                                    marginTop: "10px",
                                    objectFit: "cover",
                                    display: "none",
                                  }}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Banner Image</label>
                                <input
                                  type="file"
                                  className="form-control"
                                  placeholder="Enter Property Image"
                                  onChange={imageUpload0}
                                />
                                <img
                                  id="output_banner_image"
                                  alt="your image"
                                  style={{
                                    height: "100px",
                                    width: "100px",
                                    marginTop: "10px",
                                    objectFit: "cover",
                                    display: "none",
                                  }}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Enter Property Brochure Image</label>
                                <input
                                  type="file"
                                  className="form-control"
                                  placeholder="Enter Property Image"
                                  onChange={imageUpload11}
                                />
                                <img
                                  id="output_brochure_image"
                                  alt="your image"
                                  style={{
                                    height: "100px",
                                    width: "100px",
                                    marginTop: "10px",
                                    objectFit: "cover",
                                    display: "none",
                                  }}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Enter Property Video</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Video Link"
                                  value={propertyVideo}
                                  onChange={(e) =>
                                    setPropertyVideo(e.target.value)
                                  }
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Gallery Images</label>
                                <br />
                                <button
                                  className="btn btn-danger"
                                  data-toggle="modal"
                                  data-target="#exampleModal5"
                                >
                                  Upload
                                </button>
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Floor Plans Images</label>
                                <br />
                                <button
                                  className="btn btn-danger"
                                  data-toggle="modal"
                                  data-target="#exampleModal12"
                                >
                                  Upload
                                </button>
                              </div>
                              {/* <div className="col-md-4 mb-4">
                                <label>Enter Floor Type</label>
                                <br />
                                <button
                                  className="btn btn-danger"
                                  data-toggle="modal"
                                  data-target="#exampleModal9"
                                >
                                  Upload
                                </button>
                              </div> */}
                              <div className="col-md-4 mb-4">
                                <label>Min Price</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Price"
                                  value={price}
                                  onChange={(e) => setMinPrice(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Max Price</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Price"
                                  value={max_price}
                                  onChange={(e) => setMaxPrice(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>No of Bedrooms</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Bedrooms"
                                  value={beds}
                                  onChange={(e) => setBeds(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>No of Bathrooms</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Bathrooms"
                                  value={bath}
                                  onChange={(e) => setBath(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Address</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Address"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Enter City</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Address"
                                  value={city}
                                  onChange={(e) => setCity(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Enter State</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Address"
                                  value={state}
                                  onChange={(e) => setState(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Parking Facility</label>
                                <select
                                  className="form-control"
                                  value={parking}
                                  onChange={(e) => setParking(e.target.value)}
                                >
                                  <option disabled selected>
                                    Parking Available
                                  </option>
                                  <option value="Y">Yes</option>
                                  <option value="N">No</option>
                                </select>
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Min Size (Squ.. Feet)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={min_area}
                                  onChange={(e) => setMinArea(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Max Size (Squ.. Feet)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={max_area}
                                  onChange={(e) => setMaxArea(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Status</label>
                                <select
                                  className="form-control"
                                  onChange={(e) =>
                                    setPropertyStatus(e.target.value)
                                  }
                                >
                                  <option disabled selected>
                                    Select Status
                                  </option>
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                </select>
                              </div>
                              {/* <div className="d-flex w-100 container" style={{flexWrap: 'wrap', columnGap: '20px'}}>
                                                {amenitiesList.current?.map((data) => {
                                                    return (    
                                                        <div>
                                                            <input id="check-3" type="checkbox" name="check" style={{marginRight: '10px'}} value={data} onChange={handleToggle} />
                                                            <label htmlFor="check-3">{data}</label>
                                                        </div>
                                                    )
                                                })}
                                            </div> */}
                              <div
                                className="col-md-12 mb-4"
                                style={{ textAlign: "left" }}
                              >
                                <label>Enter Property Short Description</label>
                                <textarea
                                  className="form-control"
                                  placeholder="Enter Short Description"
                                  value={shortDesc}
                                  onChange={(e) => setShortDesc(e.target.value)}
                                ></textarea>
                              </div>
                              <div
                                className="col-md-12 mb-4"
                                style={{ textAlign: "left" }}
                              >
                                <label>Property Details</label>
                                <textarea
                                  className="form-control"
                                  placeholder="Enter Description"
                                  value={pdetails}
                                  onChange={(value) => setPDetails(value)}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={editForm}
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal2"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Add Property Images
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              {appendDiv.map((data, key) => {
                                return (
                                  // <button className="btn btn-danger remove-btn">-</button>
                                  <div className="col-md-4 copy-div mb-3">
                                    <input
                                      className="form-control imageUpload2"
                                      type="file"
                                      id="myfile"
                                      name="myfile"
                                      onChange={imageUpload2}
                                    />
                                    <br />
                                    <img
                                      className="upload-img"
                                      id={"output" + key + 20}
                                      src={
                                        "https://api.divinebricks.com" +
                                        attachment
                                      }
                                      alt="your image"
                                    />
                                  </div>
                                );
                              })}
                              {/* <div className="col-md-4 copy-div"> */}
                              {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                                <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                              {/* </div> */}
                            </div>
                            <div
                              style={{ textAlign: "left", marginTop: "20px" }}
                            >
                              <button
                                className="btn btn-danger"
                                onClick={addDiv}
                              >
                                + Add Images
                              </button>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-dismiss="modal"
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal7"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Add Floor Plan Images
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              {appendDiv2.map((data, key) => {
                                return (
                                  // <button className="btn btn-danger remove-btn">-</button>
                                  <>
                                    <div className="col-md-4 copy-div mb-3">
                                      <input
                                        className="form-control imageUpload2"
                                        type="file"
                                        id="myfile"
                                        name="myfile"
                                        onChange={imageUpload16}
                                      />
                                      <br />
                                      {/* <select className="form-control mb-1" name="name" onChange={handleFloorArray}>
                                                                                <option disabled selected>Select No of Bedroom</option>
                                                                                <option value='1'>1 Bedroom</option>
                                                                                <option value='2'>2 Bedrooms</option>
                                                                                <option value='3'>3 Bedrooms</option>
                                                                                <option value='4'>4 Bedrooms</option>
                                                                                <option value='5'>5 Bedrooms</option>
                                                                                <option value='6'>6 Bedrooms</option>
                                                                                <option value='7'>7 Bedrooms</option>
                                                                            </select> */}
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="name"
                                        placeholder="Enter No of Bedrooms"
                                        onChange={handleFloorArray}
                                      />
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="type"
                                        placeholder="Enter Type"
                                        onChange={handleFloorArray}
                                      />
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="area"
                                        placeholder="Enter Area Size"
                                        onChange={handleFloorArray}
                                      />
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="price"
                                        placeholder="Enter Price"
                                        onChange={handleFloorArray}
                                      />
                                      <button
                                        className="bt btn-danger"
                                        onClick={saveArr}
                                      >
                                        Save
                                      </button>
                                      {/* <select className="form-control" onChange={handleOnChange}>
                                                                                <option disabled selected>Select Type</option>
                                                                                <option value='TypeA'>TypeA</option>
                                                                                <option value='TypeB'>TypeB</option>
                                                                                <option value='TypeC'>TypeC</option>
                                                                                <option value='TypeD'>TypeD</option>
                                                                            </select> */}
                                      <img
                                        className="upload-img"
                                        id={"output" + key + 80}
                                        src={
                                          "https://api.divinebricks.com" +
                                          attachment
                                        }
                                        alt="your image"
                                      />
                                    </div>
                                    {/* <div><button className="btn btn-primary" onClick={addFloorType}>Save</button></div> */}
                                  </>
                                );
                              })}
                              {/* <div className="col-md-4 copy-div"> */}
                              {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                                <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                              {/* </div> */}
                            </div>
                            <div
                              style={{ textAlign: "left", marginTop: "20px" }}
                            >
                              <button
                                className="btn btn-danger"
                                onClick={addDiv2}
                              >
                                + Add Images
                              </button>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-dismiss="modal"
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal8"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Add Floor Type
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              {appendDiv2.map((data, key) => {
                                return (
                                  // <button className="btn btn-danger remove-btn">-</button>
                                  <>
                                    <div className="col-md-4 copy-div mb-3">
                                      <select
                                        className="form-control mb-1"
                                        name="name"
                                        onChange={handleFloorArray}
                                      >
                                        <option disabled selected>
                                          Select No of Bedroom
                                        </option>
                                        <option value="1">1 Bedroom</option>
                                        <option value="2">2 Bedrooms</option>
                                        <option value="3">3 Bedrooms</option>
                                        <option value="4">4 Bedrooms</option>
                                        <option value="5">5 Bedrooms</option>
                                        <option value="6">6 Bedrooms</option>
                                        <option value="7">7 Bedrooms</option>
                                      </select>
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="type"
                                        placeholder="Enter Type"
                                        onChange={handleFloorArray}
                                      />
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="area"
                                        placeholder="Enter Area Size"
                                        onChange={handleFloorArray}
                                      />
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="price"
                                        placeholder="Enter Price"
                                        onChange={handleFloorArray}
                                      />
                                      <button
                                        className="bt btn-danger"
                                        onClick={saveArr}
                                      >
                                        Save
                                      </button>
                                    </div>
                                    {/* <div><button className="btn btn-primary" onClick={addFloorType}>Save</button></div> */}
                                  </>
                                );
                              })}
                              {/* <div className="col-md-4 copy-div"> */}
                              {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                                <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                              {/* </div> */}
                            </div>
                            <div
                              style={{ textAlign: "left", marginTop: "20px" }}
                            >
                              <button
                                className="btn btn-danger"
                                onClick={addDiv2}
                              >
                                + Add More
                              </button>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-dismiss="modal"
                              onClick={handleFloorTypes}
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal9"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Edit Floor Type
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              {oldPropertyBedroom?.map((data) => {
                                return (
                                  <div className="col-md-4 mb-3">
                                    <select
                                      className="form-control mb-1"
                                      name="name"
                                      value={data.name}
                                      onChange={handleFloorArray}
                                    >
                                      <option disabled selected>
                                        Select No of Bedroom
                                      </option>
                                      <option value="1">1 Bedroom</option>
                                      <option value="2">2 Bedrooms</option>
                                      <option value="3">3 Bedrooms</option>
                                      <option value="4">4 Bedrooms</option>
                                      <option value="5">5 Bedrooms</option>
                                      <option value="6">6 Bedrooms</option>
                                      <option value="7">7 Bedrooms</option>
                                    </select>
                                    <input
                                      type="text"
                                      className="form-control mb-1"
                                      name="type"
                                      placeholder="Enter Type"
                                      onChange={handleFloorArray}
                                    />
                                    <input
                                      type="text"
                                      className="form-control mb-1"
                                      name="area"
                                      placeholder="Enter Area Size"
                                      value={data.area}
                                    />
                                    <input
                                      type="text"
                                      className="form-control mb-1"
                                      name="price"
                                      placeholder="Enter Price"
                                      value={data.price}
                                      onChange={handleFloorArray}
                                    />
                                  </div>
                                );
                              })}
                              {appendDiv2.map((data, key) => {
                                return (
                                  // <button className="btn btn-danger remove-btn">-</button>
                                  <>
                                    <div className="col-md-4 copy-div mb-3">
                                      <select
                                        className="form-control mb-1"
                                        name="name"
                                        onChange={handleFloorArray}
                                      >
                                        <option disabled selected>
                                          Select No of Bedroom
                                        </option>
                                        <option value="1">1 Bedroom</option>
                                        <option value="2">2 Bedrooms</option>
                                        <option value="3">3 Bedrooms</option>
                                        <option value="4">4 Bedrooms</option>
                                        <option value="5">5 Bedrooms</option>
                                        <option value="6">6 Bedrooms</option>
                                        <option value="7">7 Bedrooms</option>
                                      </select>
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="type"
                                        placeholder="Enter Type"
                                        onChange={handleFloorArray}
                                      />
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="area"
                                        placeholder="Enter Area Size"
                                        onChange={handleFloorArray}
                                      />
                                      <input
                                        type="text"
                                        className="form-control mb-1"
                                        name="price"
                                        placeholder="Enter Price"
                                        onChange={handleFloorArray}
                                      />
                                      <button
                                        className="bt btn-danger"
                                        onClick={saveArr}
                                      >
                                        Save
                                      </button>
                                    </div>
                                    {/* <div><button className="btn btn-primary" onClick={addFloorType}>Save</button></div> */}
                                  </>
                                );
                              })}
                              {/* <div className="col-md-4 copy-div"> */}
                              {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                                <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                              {/* </div> */}
                            </div>
                            <div
                              style={{ textAlign: "left", marginTop: "20px" }}
                            >
                              <button
                                className="btn btn-danger"
                                onClick={addDiv2}
                              >
                                + Add More
                              </button>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-dismiss="modal"
                              onClick={handleFloorTypes}
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal5"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Edit Property Gallery Images
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              {oldGalleryImages?.map((data) => {
                                return (
                                  <div className="col-md-4 mb-3" key={data.id}>
                                    <img
                                      src={
                                        "https://api.divinebricks.com" +
                                        data.img_url
                                      }
                                      style={{
                                        width: "100%",
                                        maxHeight: "140px",
                                      }}
                                    />
                                    <button
                                      key={data.id}
                                      id={data.id}
                                      onClick={(e) => handleGalleryId(data)}
                                      style={{
                                        border: "none",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {/* <label for='update-image-test' className="btn">Edit</label> */}
                                      <input
                                        key={data.id}
                                        type="file"
                                        className="form-control"
                                        id="update-image-test"
                                        placeholder="Enter Floor Plans Image"
                                        onChange={imageUpload10}
                                      />
                                      <img
                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAgVBMVEX///8AAADT09MyMjKamprZ2dmqqqp8fHzy8vK2trZlZWX8/PxgYGB2dnb29vZJSUno6OiUlJSkpKRFRUVbW1u/v7+CgoJRUVE+Pj7MzMzq6upqampYWFgmJiYbGxs5OTkNDQ3Dw8OMjIxwcHAXFxewsLAiIiIsLCzf39+Hh4c0NDReW6b3AAAI5ElEQVR4nO2d6XrqIBCGo3WJpkbtolW7GFur7f1f4DlpLQMEEmAGTJ6H71+bFHjLMjOgQ5JERUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFWav/OFjNduPDsUiv3RQPSkfzHqf9eJNdu0mk2jz3Kvpcbq/dLDJt7qt8Pzrk124aidKphq8crJMwbcjytFaowgs9X6md5+mYDier3frtdV/bigWihmU9YK/3hCm9Qf3l/KOpfizhqrn0D0+I54MRHJJwbFS+hzU1m+hWN1rCCuBp/fzw/CTPiRdyB+B4Y8PnTigBPhzPv9Zh2/96FZ/QsZUqTnZ8zoQi4O7MP8smwsMBBdhFW4V34YdQADz1K8+/CP6JCh3t+RyrFwBvVVav4F54RnL9Kdu5ADoRCoAz9Tt97pVqH7tooZyBT++D0fE4qZGD92gC+N9hhXdIFpuNzNb73E3OzX/nIAFwrH/vDt4iaEgh8+0KX669ALivexOCxgO61keJb+UvOpPtYM2rMBW/sS641IMzj/sIFU/muabxa/YW0mAMhSrfaFYutRS+6IMeEYbWCFVrKnhJB58xmdLZ1pu7DKYNqto1X90GVVSDNNGEfi4+/L0yx1TLR0qvfuzDRdpwSTtQoW2IanlD+OZ1g0sAXA1MehFMIqLeT6iHPhTjJXsywhaGBhGCDPd6+TEaFFBGVA5UAsIzV8nQuRQDqXzRZsQRnvAdqsCZnAapne3GgQovuFbMdeHUtQwT6aKJJkTWATeuNXNd6HMPXR9NCIhVB449enesOYXSj45FmKguHhQQ5WgfXG/XvRqwSW+OJZioPuCtG6gz9sB1FQSHtHAswUBNEb0ekRtijnMI3Jl7twJM1LxloTUa7/V/ZyA4N/A3C032ZDS9WMAvXeOBt78C9t4WUrNNJ3G5ufwyhZMhV1sBxtB1LW6UGaCyFzNu7891iMEGsK91xhRQYTTyJ/j5E1+/awnGFTQByqY/yfnzL+cOYJt1T64l1MsGUO5Fft/htulPdcpZEUvXImplB6g/8v50XgbBnnr5zIMtoBbRfesP7L2PzRl7QA0i4t8P8bMHa+gCqETERK0QP9PvkLoBKhBRYTnbx/okJ3QFrCDi9h1Y6HSiJnQHTLIXOkAgRB/sSMIAfhMCAuENLSECkHfVCLbGPBFiAO9JAT0RYoYobQ96IsQA3hADeiFs0RBNvBBiAOfkgB4I2zQHS5ETtsdMXERN2LIhmpATYoYo/SLzI1rC1rhqnEgJ22UmLqIkbN8cLEVI2DYzcREdIQbwzR8gHWE7h2hCR4jpQa+AVIRtHaIJFWHrXDVOJIStnYOlKAhb6KpxIiBsVURfFZ6wla4aJzRhq+dgKSxhS101TkjC9gMiCVs/RBMkYXtdNU4Ywha7apwQhG03Exe5E3ZhDpZyJmy3q8bJlbCNu2pqORJ2ZYgmroSdMBMXORF2wJMBuRB2CtCFsENzsJQ9YZfmYClrwu6YiYtsCTviqnGyJOzYHCxlR9gZV42TFWE3wiVJNoQdHKKJFWHXzMRF5oSdHKKJBWGbD19qZUrYzTlYypBw5Q7oaiYeRxc9WlVXkRmhkF+wJuWRQs6uGsv3gUzyZUQo5Iaz+6apu6vGcpo6f+PpVyaEi56gO4viEXMwJKHQSitETMAbkLCahM8UERXRhyPkv6hqh4gzE+EIxRSUFohIVy0coTpTazMi1lULRsglPhH6pAkRHdEHI4Tvka3EfGD1iHhXLRghdEUqzaw6RIKIPhgha+au/MkQkWJXLRQh5Br8+SpuZjRQSaKJUIRgK37TMuYGiDQRfShC9vzvC/HNc5HobCIUIUsrvGa/akCkOnwJRcjM9o79qn6gkkX0oQhZehguxW1e04t0u2qBCCE0FLIaaBEJd9UCEUImMSExhc5oUB6+BCKEDLdi2gz1XCTdVQtEyLxSOeWCymjQHr4EImTGopqsroJIvLMdiJANxmrKSHkuUm/8hiHM2Q6GIgORiDQQ7owg2NkOQ6gxFhdl8iYcJWAgQogslPnudIgkZxPkhMrcJhBZqLMLi0aDFDBQHzbmt1X1ItHpEiNE5sVlhC8qQpY69KQtoIJIdXzGCJHZDiEbuIqQDcKd4uGvsgc/gAlbm+3OuiqqzfWVsYul9Plt87EfQAgzkfcgQb42xeURkJBPl3fyLFxYRHnCm+6b6jbUljVOcdSqiSxK5elwsqzcK0R4hL2oa5iNoJsUgwFOncBYZIvh4+F9LWTj8gCojWrsxYb7uvqMLbT78qfF5nEwva+5sIz0QwgkVz78aFZTEktSfBrsmq9io00tySKxb2xJYC6qjpnNBXp72hS2MHu+sEXB2VL1FhcLwDXxtR+wBKCHBgRIlcyJqZJFKfJE2eAq4e/bgIzg8rJcvaNMrY8BeVZJGFmKBdBWBStM/miO8nxb1n468XBzEnwGy+azLRrBdUqyXb9TAAl6mg02Xi5t4eYHRWpccLykThwpoH718jA4bjzehaFtkpu4k3pxxV9UyF7vbw+TjccLiBta5CqIf6TlFG6+2M/fD8fhOdCl9bBz8EpTILdmSua1WPdO78tjPw16wzm3wlE5glwQ6/ESD1Nxk8M5l74s/mJAr1eSmYg/YaVzdcH9ps+YbKsptIXA2v8J/FzSYl3E/bNJ7w/j3Ze6GzO9i9/1ob3LgLvVqjcPunIK4nuQ+G6mnN+WePFu0zWNELbQqRvB35/n6SqIJvX3fBOQG1AKFQLiNJD7AsrFjUmCmKIiKZS4C7vgPIq7d7hrY3UaiIgvAb/AU0ifRPZ1M1MlIFwGWXLSuw+pXj89WKr6xYP5cuh1Rubn0UOlUj+X+vyqqNT2P4JZz+6KTZ9cm2K0elZtw/q8hTFJtt+KKoNq7/NG8B+tmhvhU7sADtXmit34EcbVyBo32XxpFczPSK8yVKdB3eHt8rW5SaQae73RXaV8chsObz66zu5Jepw2Nw6v9d1VN4fOk6/1jacR+3Gaj4/ezZ+R8u15SK7z4np7CVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRV9E/7oN3jyQrXPcAAAAASUVORK5CYII="
                                        style={{ width: "20px" }}
                                      />
                                    </button>
                                  </div>
                                );
                              })}
                              {appendDiv.map((data, key) => {
                                return (
                                  //
                                  <div className="col-md-4 copy-div mb-3">
                                    <input
                                      className="form-control imageUpload2"
                                      type="file"
                                      id="myfile"
                                      name="myfile"
                                      onChange={imageUpload20}
                                    />
                                    <br />{" "}
                                    <img
                                      className="upload-img"
                                      id={"output" + key + 100}
                                      src={
                                        "https://api.divinebricks.com" +
                                        attachment
                                      }
                                      alt="your image"
                                    />
                                  </div>
                                );
                              })}
                              {/* <div className="col-md-4 copy-div"> */}
                              {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                                <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                              {/* </div> */}
                            </div>
                            <div
                              style={{ textAlign: "left", marginTop: "20px" }}
                            >
                              <button
                                className="btn btn-danger"
                                onClick={addDiv}
                              >
                                + Add Images
                              </button>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-dismiss="modal"
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal12"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Edit Property Floor Plan Images
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              {oldFloorPlanImages?.map((data) => {
                                return (
                                  <div className="col-md-4 mb-3">
                                    <img
                                      src={
                                        "https://api.divinebricks.com" +
                                        data.img_url
                                      }
                                      style={{
                                        width: "100%",
                                        maxHeight: "140px",
                                      }}
                                    />
                                    <button
                                      onClick={() => {
                                        setGalleryId(data?.id);
                                        setGalleryName(data?.name);
                                      }}
                                      style={{
                                        border: "none",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="update-floor-id"
                                        placeholder="Enter Floor Plans Image"
                                        onChange={imageUpload9}
                                      />
                                      <img
                                        src="data:image/png;base64,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"
                                        style={{ width: "20px" }}
                                      />
                                    </button>
                                  </div>
                                );
                              })}
                              {appendDiv.map((data, key) => {
                                return (
                                  //
                                  <div className="col-md-4 copy-div mb-3">
                                    <input
                                      className="form-control imageUpload2"
                                      type="file"
                                      id="myfile"
                                      name="myfile"
                                      onChange={imageUpload20}
                                    />
                                    <br />{" "}
                                    <img
                                      className="upload-img"
                                      id={"output" + key + 100}
                                      src={
                                        "https://api.divinebricks.com" +
                                        attachment
                                      }
                                      alt="your image"
                                    />
                                  </div>
                                );
                              })}
                              {/* <div className="col-md-4 copy-div"> */}
                              {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                                <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                              {/* </div> */}
                            </div>
                            <div
                              style={{ textAlign: "left", marginTop: "20px" }}
                            >
                              <button
                                className="btn btn-danger"
                                onClick={addDiv}
                              >
                                + Add Images
                              </button>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-dismiss="modal"
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModal6"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              View Property Details
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body add-property-modal">
                            <div className="row admin-property-add">
                              <div className="col-md-4 mb-4">
                                <label>Property Image</label>
                                <br />
                                <img
                                  src={
                                    "https://api.divinebricks.com" + propertyImg
                                  }
                                  style={{ width: "100px", height: "100px" }}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Property Banner Image</label>
                                <br />
                                <img
                                  src={
                                    "https://api.divinebricks.com" +
                                    propertyBannerImg
                                  }
                                  style={{ width: "100px", height: "100px" }}
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Gallery Images</label>
                                <br />
                                <div
                                  id="carouselExampleControls"
                                  className="carousel slide"
                                  data-ride="carousel"
                                >
                                  <div className="carousel-inner">
                                    {oldGalleryImages?.map((data1, key) => {
                                      return (
                                        <div
                                          class={
                                            key == 0
                                              ? "carousel-item active"
                                              : "carousel-item"
                                          }
                                        >
                                          <img
                                            src={
                                              "https://api.divinebricks.com" +
                                              data1?.img_url
                                            }
                                            alt=""
                                            style={{
                                              width: "100%",
                                              height: "100px",
                                            }}
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <a
                                    className="carousel-control-prev"
                                    href="#carouselExampleControls"
                                    role="button"
                                    data-slide="prev"
                                  >
                                    <span
                                      className="carousel-control-prev-icon"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">Previous</span>
                                  </a>
                                  <a
                                    className="carousel-control-next"
                                    href="#carouselExampleControls"
                                    role="button"
                                    data-slide="next"
                                  >
                                    <span
                                      className="carousel-control-next-icon"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">Next</span>
                                  </a>
                                </div>
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Floor Plans Images</label>
                                <br />
                                <div
                                  id="carouselExampleControls1"
                                  className="carousel slide"
                                  data-ride="carousel"
                                >
                                  <div className="carousel-inner">
                                    {oldFloorPlanImages?.map((data1, key) => {
                                      return (
                                        <div
                                          class={
                                            key == 0
                                              ? "carousel-item active"
                                              : "carousel-item"
                                          }
                                        >
                                          <img
                                            src={
                                              "https://api.divinebricks.com" +
                                              data1?.img_url
                                            }
                                            alt=""
                                            style={{
                                              width: "100%",
                                              height: "100px",
                                            }}
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <a
                                    className="carousel-control-prev"
                                    href="#carouselExampleControls1"
                                    role="button"
                                    data-slide="prev"
                                  >
                                    <span
                                      className="carousel-control-prev-icon"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">Previous</span>
                                  </a>
                                  <a
                                    className="carousel-control-next"
                                    href="#carouselExampleControls1"
                                    role="button"
                                    data-slide="next"
                                  >
                                    <span
                                      className="carousel-control-next-icon"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">Next</span>
                                  </a>
                                </div>
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>No of Bedrooms</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Bedrooms"
                                  value={beds}
                                  readOnly
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>No of Bathrooms</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Bathrooms"
                                  value={bath}
                                  readOnly
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Address</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={address}
                                  readOnly
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>City</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={city}
                                  readOnly
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>State</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={state}
                                  readOnly
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Min Property Size (Squ.. Feet)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={min_area}
                                  readOnly
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Max Property Size (Squ.. Feet)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={max_area}
                                  readOnly
                                />
                              </div>
                              <div className="col-md-4 mb-4">
                                <label>Parking</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Property Size"
                                  value={parking}
                                  readOnly
                                />
                              </div>
                              <div
                                className="col-md-12 mb-4"
                                style={{ textAlign: "left" }}
                              >
                                <label>Property Details</label>
                                <textarea
                                  className="form-control"
                                  placeholder="Enter Description"
                                  value={pdetails}
                                  readOnly
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AgentAddProperty;
